import { getSearchResults } from "./search.vx-api";
import { configurator } from "./config.vx-api";
import { setIsPostalCodeChanged, getIsPostalCodeChanged } from "../comparison/module.sharedPostalCodeState.js";

let filterData = null;
let searchResults = null;
let config;
let filterForm;
let updateFunction;
let storedPagingButton = "";
let settings = {
  filterForm: null,
};
const VxApiSearchTool = async ({ apiUrl, filterForm, pagingButton }) => {
  config = configurator("wj", apiUrl);
  settings.filterForm = filterForm;
  storedPagingButton = pagingButton;
  let formData = getFilterFormData();

  let { filters, results, benchmarkTariff } = await getSearchResults(config, formData);

  const pageInput = filterForm.querySelector('input[name="page"]');
  setTimeout(() => {
    pageInput.value = 1;
    setFormInputWatcher(pageInput);
  }, 200);
  pagingButton.removeAttribute("hidden");
  if (!pagingButton.dataset.vxPagingBound) {
    pagingButton.addEventListener("click", handlePagingButtonClick);
    pagingButton.dataset.vxPagingBound = "true";
  }

  return {
    comparisonData: {
      filters,
      results,
      benchmarkTariff,
      formData,
    },
    tooling: {
      onResultsUpdated,
    },
  };
};

const handlePagingButtonClick = async () => {
  const pageInput = settings.filterForm.querySelector('input[name="page"]');
  const currentPage = parseInt(pageInput.value) || 1;
  pageInput.value = currentPage + 1;
  onFiltersChanged({ skipTimeout: true });
};

const setFormInputWatcher = (pageInput) => {
  const inputs = settings.filterForm.querySelectorAll("input, select");
  Array.from(inputs)
    .filter((i) => {
      return i.dataset.skipSubmit !== "true";
    })
    .filter((i) => {
      return i.dataset.ignore !== "true";
    })
    .forEach((input) => {
      input.addEventListener("change", () => {
        pageInput.value = 1;
        onFiltersChanged({ skipTimeout: false });
      });
    });
  const priceDisplayInput = settings.filterForm.querySelector("[name=priceDisplay]");

  setPriceDisplayChangeHandler(priceDisplayInput);
};

const setPriceDisplayChangeHandler = (priceDisplayInput) => {
  priceDisplayInput.addEventListener("change", () => {
    const selectedPriceDisplay = priceDisplayInput.value;
    const wjPackageElements = document.querySelectorAll("wj-package");

    Array.from(wjPackageElements).forEach((element) => {
      element.dataset.priceDisplay = selectedPriceDisplay;
    });
  });
};

const getFilterFormData = () => {
  const inputsArr = Array.from(settings.filterForm.querySelectorAll("input, select"));
  const formProps = getUniqueFormProps(inputsArr);
  const filterFormData = {};
  inputsArr
    .filter((i) => !i.dataset.formProp)
    .forEach((input) => {
      let { value, checked, name, type } = input;
      if (type == "radio") {
        if (checked) {
          if (value === "true") {
            value = true;
          } else if (value === "false") {
            value = false;
          }
          filterFormData[name] = value;
        }
      } else if (type == "checkbox") {
        filterFormData[name] = checked;
      } else {
        filterFormData[name] = value;
      }
    });

    // Reset benchmark to -1 ONLY if postal code has changed
    if (getIsPostalCodeChanged()) {
      filterFormData.benchmark = "-1"; // Reset benchmark
      filterFormData[""] = false;
    }
  

  formProps.forEach((formProp) => {
    let myValue = [];
    myValue = inputsArr
      .filter((i) => i.dataset.formProp === formProp && i.checked)
      .map((input) => {
        let { value } = input;
        return value;
      });

    filterFormData[formProp] = myValue.join(",");
  });

  return filterFormData;

};
const getUniqueFormProps = (inputsArr) => {
  // TODO  check if needed
  const formProps = [];
  inputsArr.map((i) => {
    const formProp = i.dataset.formProp;
    if (formProp && formProps.indexOf(formProp) === -1) {
      formProps.push(formProp);
    }
  });

  return formProps;
};
let searchTimeout = 1;
const resultsWrapper = document.getElementById("packageResults");
const savingsWrapper = document.querySelector(".js-saving-banner")
const onFiltersChanged = async ({ skipTimeout = false }) => {


  if (searchTimeout) {
    clearTimeout(searchTimeout);
    searchTimeout = null;
  }

  resultsWrapper.style.filter = "blur(5px)";
  savingsWrapper.style.filter = "blur(5px)";

  const timeoutDuration = skipTimeout ? 0 : 800;
  searchTimeout = setTimeout(async () => {
    storedPagingButton.setAttribute("disabled", "disabled");

    let formValidation = formIsValid(settings.filterForm);
    if (formValidation.isValid) {
      await executeSearch();
    } else {
      console.log(formValidation.errors);
    }
    storedPagingButton.removeAttribute("disabled");
    resultsWrapper.style.filter = "";
    savingsWrapper.style.filter = "";
  }, timeoutDuration);
};

const formIsValid = (form) => {
  let isValid = true;
  let errors = [];
  const hiddenLocationInput = form.querySelector("#hiddenLocationInput").value;
  if (hiddenLocationInput == "") {
    errors.push("Kein addresse gefunden. Bitte versuchen Sie es erneut.");
    isValid = false;
  }

  return { isValid, errors };
};

const executeSearch = async (appendingData) => {
  // only execute the search if the postal code has not changed
    if (!getIsPostalCodeChanged()) {
      let searchData = getFilterFormData();
      searchData.resultsOnly = true;
      let formData = { ...searchData, ...appendingData };
      let { filters, results, benchmarkTariff} = await getSearchResults(config, searchData);
      updateFunction({ filters, results, benchmarkTariff, formData });
      setIsPostalCodeChanged(false); // Reset the flag
    }

};
const onResultsUpdated = (updateData) => {
  updateFunction = updateData;
};

export { VxApiSearchTool };
